import React from 'react';
import {
  AlertTriangle,
  Apple,
  ArrowLeft,
  ArrowRight,
  Banknote,
  BarChart3,
  Bell,
  Briefcase,
  Calendar,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronRight,
  Circle,
  Clock,
  Copy,
  CreditCard,
  Download,
  Dumbbell,
  ExternalLink,
  Eye,
  FileCheck,
  FileText,
  Filter,
  Gauge,
  Gift,
  GraduationCap,
  Home,
  Image,
  Inbox,
  Layers,
  LayoutDashboard,
  Link as LinkIcon,
  Lock,
  LogOut,
  Mail,
  MessageCircle,
  MoreVertical,
  Music,
  Pause,
  Play,
  Plus,
  Receipt,
  RefreshCw,
  Repeat,
  Salad,
  Search,
  Settings,
  SlidersHorizontal,
  Store,
  Trash2,
  TrendingUp,
  Upload,
  User,
  Users,
  Wallet,
  X,
  XCircle,
} from 'lucide-react';

// Registro estático de iconos (import nombrado => tree-shakeable; evita bundlear el set completo).
// Añadir aquí cualquier icono nuevo que use una pantalla.
const REGISTRY = {
  'alert-triangle': AlertTriangle,
  apple: Apple,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  banknote: Banknote,
  briefcase: Briefcase,
  dumbbell: Dumbbell,
  'file-check': FileCheck,
  'graduation-cap': GraduationCap,
  'bar-chart-3': BarChart3,
  bell: Bell,
  calendar: Calendar,
  check: Check,
  'check-circle': CheckCircle,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  circle: Circle,
  clock: Clock,
  copy: Copy,
  'credit-card': CreditCard,
  download: Download,
  'external-link': ExternalLink,
  eye: Eye,
  'file-text': FileText,
  filter: Filter,
  gauge: Gauge,
  gift: Gift,
  home: Home,
  image: Image,
  inbox: Inbox,
  layers: Layers,
  'layout-dashboard': LayoutDashboard,
  link: LinkIcon,
  lock: Lock,
  'log-out': LogOut,
  mail: Mail,
  'message-circle': MessageCircle,
  'more-vertical': MoreVertical,
  music: Music,
  pause: Pause,
  play: Play,
  plus: Plus,
  receipt: Receipt,
  'refresh-cw': RefreshCw,
  repeat: Repeat,
  salad: Salad,
  search: Search,
  settings: Settings,
  'sliders-horizontal': SlidersHorizontal,
  store: Store,
  'trash-2': Trash2,
  'trending-up': TrendingUp,
  upload: Upload,
  user: User,
  users: Users,
  wallet: Wallet,
  x: X,
  'x-circle': XCircle,
};

/**
 * Icon — GetPay93 glyph. Envuelve el set Lucide (bundleado vía lucide-react, sin fetch CDN).
 * Nombres kebab-case desde el registro estático de arriba; desconocido => círculo de fallback.
 */
export function Icon({ name = 'circle', size = 24, strokeWidth = 2, color = 'currentColor', style = {}, ...rest }) {
  const Cmp = REGISTRY[name] || Circle;
  return (
    <Cmp
      size={size}
      strokeWidth={strokeWidth}
      color={color}
      style={{ flexShrink: 0, display: 'inline-block', verticalAlign: 'middle', ...style }}
      aria-hidden="true"
      {...rest}
    />
  );
}
